




























import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import RecaptchaComponent from '@/shared/captchaComponent/RecaptchaComponent.vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { PageTitleConfig } from '@/shared/msw-app-title/type';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import ApiServiceWrapper from '@/shared/api-request.service';

@Component({
  components: {
    ...UUIFComponents,
    RecaptchaComponent,
    MswAppTitle,
    SwTextfield,
  },
})
export default class SwForgotPassword extends SwExtendedVue {
  declare $v: any;

  email: string = '';
  emailError: string = '';
  captchaError: string = '';
  submitted: boolean = false;

  created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email as string;
    }
  }

  goBack() {
    this.$router.back();
  }

  submit() {
    this.emailError = '';
    this.captchaError = '';

    if (!this.email.trim()) {
      this.emailError = this.$t('login.usernameRequired').toString();
      return;
    }

    const captchaResult = (this.$refs.recaptchaRef as RecaptchaComponent).fetchCaptcha();
    if (captchaResult.status === 'error') {
      this.captchaError = captchaResult.msg;
      return;
    }

    this.$store.commit('startLoading');
    ApiServiceWrapper.get(`users/forgot-password?emailAddress=${encodeURIComponent(this.email.trim())}&captchaText=${encodeURIComponent(captchaResult.response)}&mode=workspace`)
      .then((res: any) => {
        this.$store.commit('stopLoading');
        if (res && res.operationStatus === 'OK') {
          this.submitted = true;
        } else {
          this.emailError = res.msgDesc || this.$t('login.forgotPasswordError').toString();
        }
      })
      .catch(() => {
        this.$store.commit('stopLoading');
        this.emailError = this.$t('login.forgotPasswordError').toString();
      });
  }

  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('login.resetPasswordTitle').toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: false,
      isShowSlash: false,
      isShowParent: false,
    };
  }
}
